"use client";
import { useEffect, useState } from "react";
import Link from "next/link";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@workspace/ui/components/card";
import { Button } from "@workspace/ui/components/button";
import {
  listAppointments,
  type Appointment,
} from "@/core/appointment/repository";

export function AlertasAgenda() {
  const [alertas, setAlertas] = useState<Appointment[]>([]);
  useEffect(() => {
    let active = true;
    async function poll() {
      const now = new Date();
      const from = new Date(now.getTime() - 24 * 60 * 60 * 1000);
      const result = await listAppointments(from, now);
      if (!active || result.isErr()) return;
      setAlertas(
        result.value.filter(
          (item) =>
            item.status === "scheduled" &&
            new Date(item.startsAt).getTime() <= now.getTime() &&
            sessionStorage.getItem(`agenda-alerta-${item.id}`) !== "visto",
        ),
      );
    }
    void poll();
    const timer = window.setInterval(() => void poll(), 30000);
    return () => {
      active = false;
      window.clearInterval(timer);
    };
  }, []);
  return (
    <div
      className="fixed bottom-4 right-4 z-50 flex max-h-[60vh] w-80 max-w-[calc(100vw-2rem)] flex-col gap-2 overflow-auto"
      aria-live="polite"
    >
      {alertas.map((item) => (
        <Card key={item.id}>
          <CardHeader>
            <CardTitle>Compromisso: {item.title}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 text-sm">
            <p>
              {new Date(item.startsAt).toLocaleString("pt-BR")}
              {item.customerSnapshot?.fullName
                ? ` · ${item.customerSnapshot.fullName}`
                : ""}
            </p>
            <div className="flex gap-2">
              <Button asChild variant="outline" size="sm">
                <Link href="/agenda">Abrir agenda</Link>
              </Button>
              <Button
                size="sm"
                onClick={() => {
                  sessionStorage.setItem(`agenda-alerta-${item.id}`, "visto");
                  setAlertas((items) => items.filter((i) => i.id !== item.id));
                }}
              >
                Dispensar
              </Button>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
